module.exports = __webpack_public_path__ + "images/levels-logo-white-small_c8b40b25c0704dd89794649c1025843f.png";